/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { LeaderRatingToken } from '../models/LeaderRatingToken';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class LeaderRatingTokensService {

    /**
     * @returns LeaderRatingToken
     * @throws ApiError
     */
    public static leaderRatingTokensRetrieve({
        token,
    }: {
        token: string,
    }): CancelablePromise<LeaderRatingToken> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/leader-rating-tokens/{token}/',
            path: {
                'token': token,
            },
        });
    }

}
